import React from 'react';

const footerLinks = [
  { label: 'Algemene voorwaarden', href: '/policies/terms-conditions' },
  { label: 'Privacy beleid', href: '/policies/privacy-policy' },
  { label: 'Cookie beleid', href: '/policies/cookie-policy' },
];

export const LandingNav: React.FC = () => {
  return (
    <header className="landing-cream border-b border-blue-100/80">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <a
          href="/"
          className="text-xl font-medium tracking-tight text-blue-500 uppercase shrink-0"
          style={{ fontFamily: 'Syne, sans-serif' }}
        >
          Viresmo
        </a>
        <nav className="flex items-center gap-4 sm:gap-6 text-sm font-medium">
          <a
            href="https://versbox.be/"
            className="text-[#65635d] hover:text-[#9b51e0] transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Versbox
          </a>
          <a
            href="https://www.woyti.eu/"
            className="text-[#65635d] hover:text-[#48a43f] transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Woyti
          </a>
          <a
            href="/#login"
            className="inline-flex items-center rounded-full bg-blue-500 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-600"
          >
            Inloggen
          </a>
        </nav>
      </div>
    </header>
  );
};

export const LandingFooter: React.FC = () => {
  return (
    <footer className="bg-[#27272a] text-white/70">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 sm:py-14">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
          <div>
            <p className="landing-display text-2xl text-blue-400 tracking-tight uppercase">Viresmo</p>
            <p className="mt-2 text-sm text-white/40">
              We Offer You Today&apos;s Inspiration — via Versbox &amp; Woyti
            </p>
            <address className="mt-5 not-italic text-sm leading-relaxed text-white/45">
              <p className="text-white/55">Meat-time vof</p>
              <p>André De Bruynestraat 7</p>
              <p>9030 Mariakerke</p>
              <p>België</p>
              <p className="mt-2">BE 0654.941.327</p>
              <p>
                <a href="mailto:info@viresmo.com" className="hover:text-white transition-colors">
                  info@viresmo.com
                </a>
              </p>
              <p>
                <a href="tel:+32496368715" className="hover:text-white transition-colors">
                  tel +32 496 36 87 15
                </a>
              </p>
            </address>
            <p className="mt-4 text-sm text-white/35">&copy; {new Date().getFullYear()} Viresmo</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
            {footerLinks.map((link) => (
              <a key={link.href} href={link.href} className="hover:text-white transition-colors">
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};
